import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SnRouteBackDirective, SnRouteForwardDirective } from './directives';

@NgModule({
  imports: [CommonModule],
  exports: [SnRouteBackDirective, SnRouteForwardDirective],
  declarations: [SnRouteBackDirective, SnRouteForwardDirective],
})
export class SnRouterModule {}
